import { Component, Input, OnInit, ChangeDetectorRef, input, viewChild, output } from '@angular/core';
import { PipeModule } from '@app/pipe/pipe.module';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
@Component({
    selector: 'imageslider',
    templateUrl: './imageslider.component.html',
    styleUrls: ['./imageslider.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        PipeModule,
        MatIconModule
    ]
})
export class ImagesliderComponent implements OnInit {
    @Input()
    set data(v: string[]) {
        this._data = v;
        this.init();
    }

    get data() {
        return this._data;
    }
    @Input() current: number = 0;
    readonly showImages = input<boolean>(true);
    readonly radiustopleft = input<boolean>(false);
    readonly radiustopright = input<boolean>(false);
    readonly radiusbottomleft = input<boolean>(false);
    readonly radiusbottomright = input<boolean>(false);
    readonly showcounter = input<boolean>(true);
    readonly clickOnImg = output<number>();
    readonly imageslidercontent = viewChild<{
    nativeElement: {
        offsetWidth: number;
        scrollLeft: number;
    };
}>('imageslidercontent');
    scroll: boolean = false;
    desktopTemplate: string = 'xl';
    currentimgposition: number = 0;
    developpement: boolean = true;

    _data: string[];

    constructor(protected mediaObserver: BreakpointObserver, private cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.init();
        this.initMedia();
    }

    async initMedia() {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
        this.cdr.detectChanges();
    }

    init() {
        if (this._data?.length > 0) {
            for (let i = 0; i < this._data?.length; i++) {
                this._data[i] = this._data?.[i]?.replace(/http:/g, 'https:');
            }
        } else {
            this._data = ['../../assets/images/empty.jpg'];
        }
        this.cdr.detectChanges();
    }

    handelError(index) {
        if (this._data?.length > index) {
            this._data.splice(index, 1);
        }
        this.cdr.detectChanges();
    }

    async previus(ev) {
        ev.stopPropagation();
        const imageslidercontent = this.imageslidercontent();
        if (imageslidercontent && imageslidercontent.nativeElement) {
            if (this.current > 0) {
                this.current -= 1;
                const scrollPos = imageslidercontent.nativeElement.offsetWidth * this.current;
                imageslidercontent.nativeElement.scrollLeft = scrollPos;
            }
        }
        this.cdr.detectChanges();
    }

    async next(ev) {
        ev.stopPropagation();
        const imageslidercontent = this.imageslidercontent();
        if (imageslidercontent && imageslidercontent.nativeElement) {
            if (this.current < this._data.length - 1) {
                this.current += 1;
                const scrollPos = imageslidercontent.nativeElement.offsetWidth * this.current;
                imageslidercontent.nativeElement.scrollLeft = scrollPos;
            }
        }
        this.cdr.detectChanges();
    }

    async scrolling() {
        const imageslidercontent = this.imageslidercontent();
        if (imageslidercontent && imageslidercontent.nativeElement) {
            const wd = imageslidercontent.nativeElement.offsetWidth;
            const sc = imageslidercontent.nativeElement.scrollLeft;
            if (wd > 0) {
                this.current = Math.round(sc / wd);
            }

            this.currentimgposition = this.current;
        }
        this.cdr.detectChanges();
    }

    async sendClick() {
        this.clickOnImg.emit(this.current);
    }
}
